import { render, staticRenderFns } from "./RouteTable.vue?vue&type=template&id=15dabccd&scoped=true"
import script from "./RouteTable.vue?vue&type=script&lang=ts"
export * from "./RouteTable.vue?vue&type=script&lang=ts"
import style0 from "../style.scss?vue&type=style&index=0&id=15dabccd&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15dabccd",
  null
  
)

export default component.exports